import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody } from "reactstrap";
import ReactApexChart from 'react-apexcharts';

const MonthlyEarnings = ({ dashboardData }) => {
    const [options, setOptions] = useState({
        colors: ['#28bbe3', '#F0F1F4'],
        chart: {
            stacked: true,
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                columnWidth: '70%',
            },
        },
        grid: {
            borderColor: '#f8f8fa',
            row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
            },
        },
        xaxis: {
            categories: [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
            labels: {
                formatter: function (val) {
                    return val;
                },
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            }
        },
        yaxis: {
            title: {
                text: undefined
            },
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val;
                }
            }
        },
        fill: {
            opacity: 1
        },
        legend: {
            show: false,
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
        }
    });

    const [series] = useState([{
        name: 'Series A',
        data: [150, 300, 200, 300, 1000, 750, 500, 450, 500, 400, 100, 800]
    }, {
        name: 'Series B',
        data: [200, 400, 500, 800, 900, 650, 400, 650, 400, 650, 900, 650]
    }]);


    useEffect(() => {
        console.log("dashboardData", dashboardData);
    }, [dashboardData]);

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <h4 className="card-title mb-4">Batch Detail</h4>

                    <Row className="text-center mt-4">
                        <Col xs="6">
                            <h5 className="font-size-20">
                                {dashboardData?.batchCount === null || dashboardData?.batchCount === 0 ? "0" : dashboardData?.batchCount || "--"}
                            </h5>
                            <p className="text-muted">Batch Created</p>
                        </Col>
                        <Col xs="6">
                            <h5 className="font-size-20">
                                {dashboardData?.batchStudentCount === null || dashboardData?.batchStudentCount === 0 ? "0" : dashboardData?.batchStudentCount || "--"}
                            </h5>
                            <p className="text-muted">Student Enrolled</p>
                        </Col>
                    </Row>

                    <div id="morris-bar-stacked" className="morris-charts morris-charts-height" dir="ltr">
                        <ReactApexChart options={options} series={series} type="bar" height="290" />
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default MonthlyEarnings;
